/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useRef } from 'react'
import InputBox from '../../../components/InputBox'
import ErrorMessage from '../../../components/ErrorMessage'
import TextArea from '../../../components/TextArea'
import Dropdown from '../../../components/Dropdown'
import { useState ,useContext,useEffect} from 'react'
import { useCallback } from 'react'
import Debounce from '../../../CommonMethods/Debounce'
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick'
import { useParams,useLocation} from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import GlobalContext from '../../../components/Context/GloablContext'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import moment from 'moment'
import Loader from '../../../components/Loader'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import CustomDatePicker from '../../../components/DatePicker'
import PhoneNumberValidator from '../../../components/PhoneNumberInput'
import { dataService } from '../../../services/data.services'
import MonitorsDropdownwithSearch from './Components/MonitorsDropdownwithSearch'
import OrganizationDropdownWithSearch from '../../ManageProvider/Components/DropdownWithSearch'
import SubdivisionDropdownWithSearch from '../../ManageProvider/Components/SubdivisionDropdown/subdivassociationobserver'
import { useGetMonitorOrganizationsQuery } from '../../../features/manageMonitorSlice'
import { useLazyGetSubDivQuery } from '../../../features/organizationUserSlice'
import MonitoringTable from './Components/MonitoringTable'
import { useDeleteMonitorAssociatedToPatientMutation, useDeleteObserverAssociatedToPatientMutation, useDeleteProviderAssociatedToPatientMutation, useLinkMonitortoPatientMutation , useLinkObservertoPatientMutation, useLinkProvidertoPatientMutation} from '../../../features/patientSlice'
import CustomOverLay from '../../../components/CustomOverLay'
import { resetMonitorArray } from '../../ManageOrganizations/monitorsSlice'
import AnimatedButton from '../../../components/Animation/AnimatedButton'
import { resetProviderArray } from '../../ManageOrganizations/usersSlice'
import ProvidersDropdownwithSearch from './Components/ProvidersDropdownWithSearch'
import {createSelector} from 'reselect'
import ProviderTable from './Components/ProviderTable'
import { phoneCodeArray } from '../../../CommonMethods/phoneNumberCountryCodes'
import ObserversDropdownwithSearch from './Components/ObserverDropdownWithSearch'
import ObserverTable from './Components/ObserverTable'
import { resetObserverArray } from '../../ManageOrganizations/observersSlice'
import { useUpdateEmailMutation } from '../../../features/apiSlice'
import { validateEmail } from '../../../CommonMethods/EmailValidator'
import TimeZoneDropdown from '../../../CommonMethods/TimeZoneDropdown'



const selectCheckedArr = state => state.monitorsSelect.selectedUsers.checkedArr[0];

const selectCheckedProviderArr = state => state.userSelect.selectedUsers.checkedArr[0]

const selectCheckedObserverArr = state => state.observersSelect.selectedUsers.checkedArr[0]
// Create a memoized selector
const selectedArrSelector = createSelector(
    [selectCheckedArr],
    checkedArr => {
    // Compute derived data here
        return checkedArr[0] === null ? checkedArr.slice(1) : checkedArr;
    }
);
const selectedProviderArrSelector = createSelector(
    [selectCheckedProviderArr],
    checkedArr => {
    // Compute derived data here
        return checkedArr[0] === null ? checkedArr.slice(1) : checkedArr;
    }
);
const selectedObserverArrSelector = createSelector(
    [selectCheckedObserverArr],
    checkedArr => {
    // Compute derived data here
        return checkedArr[0] === null ? checkedArr.slice(1) : checkedArr;
    }
);

function AddPatients({edit,
    editPatient,
    addPatientDetails,
    setAddPatientBasicDetails,
    submitSelected,
    setSubmitSelected,
    emptyField,
    setEmptyField,
    setIsDisableCancel,
    isPhoneNumberValid,
    setIsPhoneNumberValid,
    caseManagersContactDetails,
    setcaseManagersContactDetails,
    emergencyContactDetails,
    setEmergencyContactDetails,
    emailError,
    setEmailError,
    usernameError,
    setUsernameError,
    emptyArea,
    setEmptyArea,
    countryCodeVal,
    setCountryCodeVal,
    countryCodeVal2,
    setCountryCodeVal2,
    newCaseMangerCountycodes,
    setNewCaseMangerCountycodes,
    newCaseMangerValidCountrycode,
    setNewCaseMangerValidCountrycode,
    newEmergencyCountycodes,
    setNewEmergencyCountycodes,
    newEmergencyValidCountrycode,
    setNewEmergencyValidCountrycode,
    data,
    providerTrigger,
    providerResult,
    observerTrigger,
    observerResult,
    selectedOrganizationName,
    setSelectedOrganizationName,
    selectedSubdivisionId,
    setSelectedSubdivisionId,
    setIsRadioChecked,
    setIsAnyFieldFilled,
    selectedSubdivisionName,
    setSelectedSubdivisionName,
    monitorTrigger,
    monitorResult,
    changeAccess,
    setChangeAccess,
    changeProviderAccess,
    setChangeProviderAccess,
    billingAgent,
    setBillingAgent,
    sendAlert,
    setSendAlert,
    setAdministrativeNotes,
    setMedicalNotes,
    loading,
    selectedSubdivReadings,
    setSelectedSubdivReadings,
    setLoading,
    isOpenTimeZone,
    setisOpenTimeZone,
    selectedTimeZone,
    setSelectedTimezone,
    handleSelectionTimezone,
    setSearchTimeZoneValue,
    searchTimeZoneValue,
    timezones,
    setTimezones,
    filteredTimezones,
    setFilteredTimezones,
    // Patient alert props
    patientSmsAlert,
    setPatientSmsAlert,
    patientEmailAlert,
    setPatientEmailAlert,
    patientMissedReading,
    setPatientMissedReading,
    patientReadingReceived,
    setPatientReadingReceived,
    // Provider alert props
    providerSmsAlert,
    setProviderSmsAlert,
    providerEmailAlert,
    setProviderEmailAlert,
    providerMissedReading,
    setProviderMissedReading,
    // Monitor alert props
    monitorSmsAlert,
    setMonitorSmsAlert,
    monitorEmailAlert,
    setMonitorEmailAlert,
    monitorMissedReading,
    setMonitorMissedReading,
    // Observer alert props
    observerSmsAlert,
    setObserverSmsAlert,
    observerEmailAlert,
    setObserverEmailAlert,
    observerMissedReading,
    setObserverMissedReading,
    observerReadingReceived,
    setObserverReadingReceived
}) {
  
 

   
    const [skip, setSkip] = useState(true)
    const {id}=useParams()
    const [isOpen, setisOpen] = useState(false);
    const [isAllSelected,setIsAllSelected] = useState(false)
    const [isOpensub, setisOpensub] = useState(false);
    const [permissionAccess,setPermissionAccess] = useState('')
    const [isMonitorsOpen,setIsMonitorsOpen] = useState(false)
    const [isProvidersOpen,setIsProvidersOpen] = useState(false)
    const [isObserversOpen,setIsObserversOpen] = useState(false)
    const [organizationListSearch, setOrganizationListSearch] = useState({search:''});
    const dispatch = useDispatch()
    const [isMonitorPopupClick,setIsMonitorPopupClick] = useState(true)
    const [confirmationDeleteCaseManagerDetails,setConfirmationDeleteCaseManagerDetails]=useState(false)
    const [confirmationDeleteEmergencyDetails,setConfirmationDeleteEmergencyDetails]=useState(false)
    const auth=useSelector(state=>state?.auth)
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
    const ref = useRef()
    const { setToastmessage,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    const [isHover, setIsHover] = useState(false)
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isProviderAddOrDelete,setIsProviderAddOrDelete] = useState(false)
    const [isObserverAddOrDelete,setIsObserverAddOrDelete] = useState(false)
    const [queryParamsOrg,setQueryParamsOrg] = useState('dropdown=true')
    const [deleteIndex, setDeleteIndex]=useState("")
    const [isOnType,setIsOnType] = useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const { data: organizationData, isFetching: organizationFetching } = useGetMonitorOrganizationsQuery(
        queryParamsOrg,  { refetchOnMountOrArgChange: true }
    );
    const [deleteLoading,setdeleteLoading] = useState(false)
    const [subTrigger, subresult, lastPromiseinfo1] = useLazyGetSubDivQuery();
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
   
    const [monitorDataList,setMonitorDataList] = useState('')
    const [monitorDataLoading,setMonitorDataLoading] = useState(false)

    const [linkMonitorToPatient] = useLinkMonitortoPatientMutation()
    const [linkObserverToPatient] = useLinkObservertoPatientMutation()
    const [linkProviderToPatient] = useLinkProvidertoPatientMutation()
    const [deleteAssociatedMonitor] = useDeleteMonitorAssociatedToPatientMutation()
    const [deleteAssociatedProvider] = useDeleteProviderAssociatedToPatientMutation()
    const [deleteAssociatedObserver] = useDeleteObserverAssociatedToPatientMutation()
    const [providerDataList,setProviderDataList] = useState('')
    const [providerDataLoading,setProviderDataLoading] = useState(false)

    const [observerDataList,setObserverDataList] = useState('')
    const [observerDataLoading,setObserverDataLoading] = useState(false)

    const [deleteModel, setDeleteModel] = useState(false);
    const [selectedRowtoDelete, setSelectedRowtoDelete] = useState({});
    const [linkOrganizationModel, setLinkOrganizationModel] = useState(false);
    const [emailButtonLoading,setEmailButtonLoading]=useState(false)
    const [emailVefiedButton,setEmailVeriedButton]=useState(true);
    const [updateEmail] = useUpdateEmailMutation()
    const [statusToggle, setStatusToggle] = useState(false)
    const [confirmationStateStatus,setConfirmationStateStatus]=useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)

    
 
    //const selectedArr=useSelector(state=>state.monitorsSelect.selectedUsers.checkedArr[0][0]===null?state.monitorsSelect.selectedUsers.checkedArr[0].slice(1):state.monitorsSelect.selectedUsers.checkedArr[0])
    const selectedArr = useSelector(selectedArrSelector);
    const providerArr = useSelector(selectedProviderArrSelector)
    const observerArr = useSelector(selectedObserverArrSelector)
   
    const handleConfirmDelete = async (type) => {
        setdeleteLoading(true)
        let monitor_id=selectedRowtoDelete?.monitorUserData?.user_id
        let patient_id=data[0]?.patient_id
        let provider_id=selectedRowtoDelete?.providerUserData?.user_id
        let response = {}
        type===undefined? response = await deleteAssociatedMonitor({patient_id,monitor_id}):response= await deleteAssociatedProvider({patient_id,provider_id})
        if (response?.error ) {
            setToastErrorMessage(response?.error?.data?.message)
            setDeleteModel(false)
            setdeleteLoading(false)
           
        } else{
            setToastmessage(`${type===undefined?'Monitor user':'Provider'} removed successfully`)
            setDeleteModel(false)
            setdeleteLoading(false)
            type===undefined?monitorTrigger(data?.[0]?.patient_id):providerTrigger(`${data?.[0]?.patient_id}${userType==='corporate-user'?'&action=view':''}`)
        }
    
    }

    const handleConfirmDeleteObserver = async () => {
        setdeleteLoading(true)
        let observer_id=selectedRowtoDelete?.user_id
        let patient_id=data[0]?.patient_id
        let response = {}
        response = await deleteAssociatedObserver({patient_id,observer_id})
        if (response?.error ) {
            setToastErrorMessage(response?.error?.data?.message)
            setDeleteModel(false)
            setdeleteLoading(false)
           
        } else{
            setToastmessage('Care partner removed successfully')
            setDeleteModel(false)
            setdeleteLoading(false)
            observerTrigger(data?.[0]?.patient_id)
        }
    
    }

    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    const handleCloseDeleteModal = () => {
        setDeleteModel(false)
    }

    const handleCloseLinkModel = () => {
        setLinkOrganizationModel(false)
    }
    
    const handleAddAssociation = async(type) =>{
        setdeleteLoading(true)
        let body = {}
        type===undefined?body={
            "monitor_users": selectedArr,
            "subdivision_id": selectedSubdivisionId,
            "subdivision_name":selectedSubdivisionName,
            "organization_id":selectedOrganizationName?.organization_id,
            "organization_name":selectedOrganizationName?.organization_name
            
        }:body={
            "providers": providerArr,
            "subdivision_id": selectedSubdivisionId,
            "subdivision_name":selectedSubdivisionName,
            "organization_id":selectedOrganizationName?.organization_id,
            "organization_name":selectedOrganizationName?.organization_name
        }
      
        
        let patient_id=data?.[0]?.patient_id
        let response;
        type===undefined?response=await linkMonitorToPatient({patient_id,body}):response=await linkProviderToPatient({patient_id,body})
        if(response?.data?.message === `${type===undefined?'Monitor users':'Providers'} associated successfully`) {
            setToastmessage(`${type===undefined?'Monitor users':'Providers'} associated successfully`)
            setLinkOrganizationModel(false)
            type===undefined?monitorTrigger(data?.[0]?.patient_id):providerTrigger(`${data?.[0]?.patient_id}${userType==='corporate-user'?'&action=view':''}`)
            setdeleteLoading(false)
            type===undefined?dispatch(resetMonitorArray()):dispatch(resetProviderArray())
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            type===undefined?setIsMonitorsOpen(false):setIsProvidersOpen(false)
            setLinkOrganizationModel(false)
            setdeleteLoading(false)
          
        }
 
    }

    const handleAddObserverAssociation = async() =>{
        setdeleteLoading(true)
        let body = {}
        body={
            "observers": observerArr,
            "subdivision_id": selectedSubdivisionId,
            "organization_id":selectedOrganizationName?.organization_id,
        }
      
        
        let patient_id=data?.[0]?.patient_id
        let response;
        response=await linkObserverToPatient({patient_id,body})
        if(response?.data?.message === `Care partners associated successfully`) {
            setToastmessage('Care partners associated successfully')
            setLinkOrganizationModel(false)
            observerTrigger(data?.[0]?.patient_id)
            setdeleteLoading(false)
            dispatch(resetObserverArray())
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            setIsObserversOpen(false)
            setLinkOrganizationModel(false)
            setdeleteLoading(false)
          
        }
 
    }

    function calculateAge(inputDate) {
        // Parse the input date string
        const birthDate = new Date(inputDate);
        
        // Get the current date
        const currentDate = new Date();
        
        // Check if the birthday has occurred this year
        const hasBirthdayOccurred = (
            currentDate.getMonth() > birthDate.getMonth() ||
            (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() >= birthDate.getDate())
        );
    
        // Calculate the age in years
        const age = currentDate.getFullYear() - birthDate.getFullYear() - (hasBirthdayOccurred ? 0 : 1);
        
        return age;
    }

    const handleChangeOrg=(value)=>{
        if(value!==''){
            setQueryParamsOrg(`search=${encodeURIComponent(value)}&dropdown=true`)
        }else{
            setQueryParamsOrg('dropdown=true')
        }
    }

    const handleOrganizationSearchTrigger=useCallback(
        Debounce((value)=>handleChangeOrg(value,id)),[]
    )
    //  handle organization search
    const handleOrganizationListSearch = (value) => {
        setOrganizationListSearch({search:value})
        handleOrganizationSearchTrigger(value)
      
    };
  
    
    const handleChange=(val,id)=>{
        if(val?.trim()!==''){
            subTrigger(`dropdown=true&filter=true&organization_id=${id}&search=${encodeURIComponent(val)}&table=patients`)

        }else{
            subTrigger(`dropdown=true&filter=true&organization_id=${id}&table=patients`)
        }
        
    }

    const handleSubdivisionSearchTrigger=useCallback(     
        Debounce((value,id)=>handleChange(value,id)),
        []

    )
    // handle subdivision search
    const handleSubdivisionListSearch = (value,isApiCall) => {
        setSelectedOrganizationName((prevSearch) => {
            if (value !== '') {
                return {
                    ...prevSearch,
                    sub_division_name: value,
                };
            } else {
                // Remove the search key from the state if the value is empty
                const { sub_division_name, ...rest } = prevSearch;
                return rest;
            }
        });
        isApiCall===undefined&&handleSubdivisionSearchTrigger(value,selectedOrganizationName.organization_id)    
    }
    
    const handleFetchSubdivision = (item) => {
        if(selectedArr?.length>0){
            dispatch(resetMonitorArray())
        }
        if(providerArr?.length>0){
            dispatch(resetProviderArray())
        }
        if(observerArr?.length>0){
            dispatch(resetObserverArray())
        }
        setEmptyField(false);
        setSelectedOrganizationName((prevState) => ({
            ...prevState,
            organization_name: item.organization_name,
            organization_id: item.organization_id,
        }));
        subTrigger(`dropdown=true&filter=true&organization_id=${item?.organization_id}&table=patients`)
        setisOpen(false);
        setSelectedSubdivisionId('')
        setSelectedSubdivisionName('')
        // this is use for refresh the subdivision value

    }

    const handleSelectionSubdivision = async(item,orgId,fromuseeffect) => {
        if(selectedArr?.length>0){
            dispatch(resetMonitorArray())
        }
        if(providerArr?.length>0){
            dispatch(resetProviderArray())
        }
        if(observerArr?.length>0){
            dispatch(resetObserverArray())
        }
        setEmptyField(false);
        setSelectedSubdivisionName(item?.sub_division_name)
        setSelectedSubdivisionId(item?.subdivision_id)
        setSelectedSubdivReadings((prev)=>({
            ...prev,
            no_of_readings:(item?.number_of_readings!==null&&item?.number_of_readings!=='')?item?.number_of_readings:'0',
            no_of_days:(item?.number_of_time_periods!==null&&item?.number_of_time_periods!=='')?item?.number_of_time_periods:'0',
            time_period:(item?.time_period===''||item?.time_period===null)?'day(s)':item?.time_period?.toLowerCase()
        }))
      
        fromuseeffect===undefined&&setAddPatientBasicDetails(prevState => ({
            ...prevState,
            number_of_readings: (item?.number_of_readings!==null&&item?.number_of_readings!=='')?item?.number_of_readings:'0',
            number_of_time_periods: (item?.number_of_time_periods!==null&&item?.number_of_time_periods!=='')?item?.number_of_time_periods:'0',
            time_period: item.time_period===""?'Day(s)':item?.time_period,
        }));
        setisOpensub(false);
        if(edit){
            let endpoint=`patients/list-monitor-users?organization_id=${orgId===undefined?selectedOrganizationName.organization_id:orgId}&subdivision_id=${item?.subdivision_id}`
            try{
                setMonitorDataLoading(true)
                const response = await dataService.GetAPI(endpoint)
                setMonitorDataLoading(false)
                setMonitorDataList(response?.data?.data)
               
            }catch(error){
                setMonitorDataLoading(false)
                setToastErrorMessage(error?.message)
            }
            let endpoint2=`patients/list-provider?organization_id=${orgId===undefined?selectedOrganizationName.organization_id:orgId}&subdivision_id=${item?.subdivision_id}`
            try{
                setProviderDataLoading(true)
                const response2 = await dataService.GetAPI(endpoint2)
                setProviderDataLoading(false)
                setProviderDataList(response2?.data?.data)
               
            }catch(error){
                setProviderDataLoading(false)
                setToastErrorMessage(error?.message)
            }
            let endpoint3=`observers/observer-dropdown?filter=true&subdivision_id=${item?.subdivision_id}`
            try{
                setObserverDataLoading(true)
                const response3 = await dataService.GetAPI(endpoint3)
                setObserverDataLoading(false)
                setObserverDataList(response3?.data?.data)
               
            }catch(error){
                setObserverDataLoading(false)
                setToastErrorMessage(error?.message)
            }
        }
        
    }

    function handleSelectDate(id,date,dateString,termkey){
        setIsAnyFieldFilled(true)
        if(id==="date_of_birth"){

            setAddPatientBasicDetails((prev) => ({
                ...prev,
                'date_of_birth': dateString,
                age: calculateAge(dateString), // Assuming calculateAge is a function that calculates age
            }));   
        }
        else if(id==="onboarding_date"){
            setAddPatientBasicDetails((prev) => ({
                ...prev,
                'onboarding_date': dateString,
            })); 
        }
        else if(id==="monitor_cycle_start_date"){
            setAddPatientBasicDetails((prev) => ({
                ...prev,
                'monitor_cycle_start_date': dateString,
            })); 
        }
        
    }
    function handleOnChangeUserDetails(id, option) {
        setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);
        setSubmitSelected(false)
        setEmailError({
            email_error: false,
            username_error: false,
            text:false
        });

        const fieldToUpdate = {
            user_name: "user_name",
            first_name: "first_name",
            middle_name: "middle_name",
            last_name: "last_name",
            email_addr: "email_addr",
            mobile_number: "mobile_number",
            main_number: "main_number",
            date_of_birth: "date_of_birth",
            age: "age",
            gender: "gender",
            address: "address",
            primary_identifier: "primary_identifier",
            secondary_identifier: "secondary_identifier",
            onboarding_date: "onboarding_date",
            weightKg: "weightKg",
            weightlbs: "weightlbs",
            no_of_readings:"number_of_readings",
            no_of_time_period2:"number_of_time_periods",
            time_period:"time_period",

            patient_status: "patient_status",
            monitor_status: "monitor_status",
        }[id];


        const regex = /^[1-9]\d*$/;
        const regexConversionWeight = /^\d{1,4}(\.\d{0,1})?$|^$/; // 4 integers and 1 decimal for weight
        
        let sanitizedOption = option;
        let isValid = true;
        let conversionValid= true;

        if (id === "mobile_number" || id === "main_number"||id==="no_of_readings"||id==="no_of_time_period2") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid = false;
            
            }
        }

        

        // weight conversion
        let updatedWeightFields = {};

        if (id === "weightKg") {
            
            // Convert kg to lbs and update weightlbs field
            const lbsValue = convertKgToLbs(sanitizedOption);
            
            updatedWeightFields = {
                weightlbs: conversionValid && sanitizedOption === "" ? "":!conversionValid&& sanitizedOption===""? "": lbsValue.toFixed(1),
            };
        } else if (id === "weightlbs") {
            // Convert lbs to kg and update weightKg field
            const kgValue = convertLbsToKg(sanitizedOption);
            updatedWeightFields = {
                weightKg: conversionValid && sanitizedOption === "" ? "" : !conversionValid&& sanitizedOption===""? "": kgValue.toFixed(1),
            };
        }


        if (!isValid) {
            
            if (fieldToUpdate) {
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption,
                    ...updatedWeightFields,
                }));
            }
            return;
        }
        if (fieldToUpdate) {

            if(fieldToUpdate==="monitor_status"){
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    "monitor_status": !addPatientDetails.monitor_status,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number"||fieldToUpdate==="number_of_time_periods"||fieldToUpdate==="number_of_readings"){
                if(option?.length<=20){
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="middle_name"){
                if(option?.length<=20){
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="last_name" || fieldToUpdate==="primary_identifier" || fieldToUpdate==="secondary_identifier"){
                if(option?.length<=30){
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="email_addr"||fieldToUpdate==="user_name"){
                setUsernameError(false)
                setEmailVeriedButton(true)
                setEmailButtonLoading(false)
                if(option?.length<=80){
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.replace(/\s/g, ''),
                    }));
                }
            }
          
            else if(fieldToUpdate==="weightKg"||fieldToUpdate==="weightlbs"){
                if(regexConversionWeight.test(sanitizedOption)){
            
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: sanitizedOption,
                        ...updatedWeightFields,
                    }));
                }
            }
            else{
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption,
                    ...updatedWeightFields,
                }));
                // Check if the sanitizedOption is an empty string
                if (sanitizedOption === "") {
                    // Clear only the respective fields (height or weight)
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [id]: "",
                    }));
                }
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }            
        }
    }
    const handleOnChangeCaseMangerContact = (id, option, index) => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setSubmitSelected(false)
    
        const fieldToUpdate = {
            case_manager_name: 'case_manager_name',
            mobile_number: 'mobile_number',
        }[id];
    
        if (fieldToUpdate) {
            setIsDisableCancel(false);
    
            const updatedCaseManagersContactDetails = [...caseManagersContactDetails];
            updatedCaseManagersContactDetails[index][fieldToUpdate] = option;
    
            setcaseManagersContactDetails(updatedCaseManagersContactDetails);
        }
    };
    const handleCOuntryCodeForObj=(index,item,id)=>{
        setIsAnyFieldFilled(true)
        const updatedCOuntryCodes = [...newCaseMangerCountycodes];
        updatedCOuntryCodes[index][id] = item.split("-")[0].trim()
        setNewCaseMangerCountycodes(updatedCOuntryCodes) 
    }

    const handlePhoneLayerValidation=(index,valid,id)=>{
        
        const updatedIsValids=[...newCaseMangerValidCountrycode]
        updatedIsValids[index][id]=valid
        setNewCaseMangerValidCountrycode(updatedIsValids)

    }
    const handleEmergencyCOuntryCodeForObj=(index,item,id)=>{
   
        const updatedCOuntryCodes = [...newEmergencyCountycodes];
        updatedCOuntryCodes[index][id] = item.split("-")[0].trim()
        setNewEmergencyCountycodes(updatedCOuntryCodes) 
        
    }

    const handleEmergencyPhoneLayerValidation=(index,valid,id)=>{
    
        const updatedIsValids=[...newEmergencyValidCountrycode]
        updatedIsValids[index][id]=valid
        
        setNewEmergencyValidCountrycode(updatedIsValids)
        
    }

    const handleOnChangeEmergencyContactDetails = (id, option, index) => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setSubmitSelected(false)
    
        const fieldToUpdate = {
            emergency_contact_name: 'emergency_contact_name',
            mobile_number: 'mobile_number',
        }[id];
    
        if (fieldToUpdate) {
            setIsDisableCancel(false);
    
            const updatedEmergencyContactDetails = [...emergencyContactDetails];
            updatedEmergencyContactDetails[index][fieldToUpdate] = option;
    
            setEmergencyContactDetails(updatedEmergencyContactDetails);
        }
    };
    
    // Convert kilograms to pounds
    function convertKgToLbs(kg) {
        const poundsPerKg = 2.20462;

        return kg * poundsPerKg;
    }

    // Convert pounds to kilograms
    function convertLbsToKg(lbs) {
        const kgPerPound = 0.453592;
        return lbs * kgPerPound;
    }

    // Convert inches to centimeters
    function convertInchToCm(inch) {
        const cmPerInch = 2.54;
        return inch * cmPerInch;
    }

    // Convert centimeters to inches
    function convertCmToInch(cm) {
        const inchPerCm = 0.393701;
        return cm * inchPerCm;
    }

    function handleCheckBox(id, option) {
        setIsAnyFieldFilled(true)
        setIsRadioChecked(true)
        setAddPatientBasicDetails((prev) => ({
            ...prev,
            [id]: option,
        }));

    }
    const handleRemoveCaseContact = () => {
        setConfirmationDeleteCaseManagerDetails(true);
    };
    const handleEmeregencyContact = () =>{
        setConfirmationDeleteEmergencyDetails(true)
    }

    const deleteContactDetails = () => {
    
        const updatedCaseManagerContactDetails = caseManagersContactDetails.filter((_, index) => index !== deleteIndex);
        const updatedCoun_fields = newCaseMangerCountycodes.filter((_, index) => index !== deleteIndex);
        const updatedPhoneValidations = newCaseMangerValidCountrycode.filter((_, index) => index !== deleteIndex);

    
        setNewCaseMangerValidCountrycode(updatedPhoneValidations);
        setNewCaseMangerCountycodes(updatedCoun_fields);
        setcaseManagersContactDetails(updatedCaseManagerContactDetails);
        
        setConfirmationDeleteCaseManagerDetails(false);
    };

    const deleteEmergencyContactDetails = () => {
    
        const updatedEmergencyContactDetails = emergencyContactDetails.filter((_, index) => index !== deleteIndex);
        
        const updatedEmergencyCountry_fields = newEmergencyCountycodes.filter((_, index) => index !== deleteIndex);
        
        const updatedPhoneValidations = newEmergencyValidCountrycode.filter((_, index) => index !== deleteIndex);
        
        
        setNewEmergencyValidCountrycode(updatedPhoneValidations);
        setNewEmergencyCountycodes(updatedEmergencyCountry_fields);
        setEmergencyContactDetails(updatedEmergencyContactDetails);
        
        setConfirmationDeleteEmergencyDetails(false);
    };
    
    const handleAddCaseContact = () => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setToastErrorMessage('');
    
        // Create a new Case Manager detail object
        const newCaseManagerDetail = { case_manager_name: '', mobile_number: '' };
    
        // Create a new country code object for the new Case Manager detail
        const newCountryCode = { mobile_number: country_code?.split('\t').join('') };
    
        // Update state to include the new Case Manager detail and its corresponding country code
        setcaseManagersContactDetails((prevDetails) => [...prevDetails, newCaseManagerDetail]);
    
        setNewCaseMangerCountycodes((prevCodes) => [
            ...prevCodes,
            newCountryCode,
        ]);
    
        // Assuming you are updating some state related to phone number validation, update it accordingly
        setNewCaseMangerValidCountrycode((prevValidations) => [
            ...prevValidations,
            { mobile_number: true },
        ]);
    };
    const handleAddEmergencyContact = () => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setToastErrorMessage('');
    
        const newEmergencyContactDetail = { emergency_contact_name: '', mobile_number: '' };
    
        const newEmergencyCountryCode = { mobile_number: country_code?.split('\t').join('') };
    
        setEmergencyContactDetails((prevDetails) => [...prevDetails, newEmergencyContactDetail]);
        
        setNewEmergencyCountycodes((prevCodes) => [
            ...prevCodes,
            newEmergencyCountryCode,
        ]);
        
        setNewEmergencyValidCountrycode((prevValidations) => [
            ...prevValidations,
            { mobile_number: true },
        ]);
    };
    
    
    const handleMoveDown = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...caseManagersContactDetails];
        const updatedCounFields = [...newCaseMangerCountycodes];
        const updatedContryCodeValidity = [...newCaseMangerValidCountrycode]

        if (currentIndex < caseManagersContactDetails.length - 1) {
            // Swap current element with the next one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex + 1]] =
                [updatedContactDetails[currentIndex + 1], updatedContactDetails[currentIndex]];
            
            [updatedCounFields[currentIndex], updatedCounFields[currentIndex + 1]] =
                [updatedCounFields[currentIndex + 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex+1]]=
                [updatedContryCodeValidity[currentIndex+1],updatedContryCodeValidity[currentIndex]]
            setcaseManagersContactDetails(updatedContactDetails);
            setNewCaseMangerCountycodes(updatedCounFields);
            setNewCaseMangerValidCountrycode(updatedContryCodeValidity)
        }
    };
    
    const handleMoveUp = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...caseManagersContactDetails];
        const updatedCounFields = [...newCaseMangerCountycodes];
        const updatedContryCodeValidity = [...newCaseMangerValidCountrycode]
        
        if (currentIndex > 0) {
            // Swap current element with the previous one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex - 1]] =
                [updatedContactDetails[currentIndex - 1], updatedContactDetails[currentIndex]];
    
            [updatedCounFields[currentIndex], updatedCounFields[currentIndex - 1]] =
                [updatedCounFields[currentIndex - 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex-1]]=
                [updatedContryCodeValidity[currentIndex-1],updatedContryCodeValidity[currentIndex]]
            
            setcaseManagersContactDetails(updatedContactDetails);
            setNewCaseMangerCountycodes(updatedCounFields);
            setNewCaseMangerValidCountrycode(updatedContryCodeValidity)
            
        }
    };

    

    const handleMoveDownEmergencyContact = (currentIndex) => {
        setIsOnType(false)
        
        const updatedContactDetails = [...emergencyContactDetails];
        const updatedCounFields = [...newEmergencyCountycodes];
        const updatedContryCodeValidity = [...newEmergencyValidCountrycode]

        if (currentIndex < emergencyContactDetails.length - 1) {
            // Swap current element with the next one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex + 1]] =
                [updatedContactDetails[currentIndex + 1], updatedContactDetails[currentIndex]];
            
            [updatedCounFields[currentIndex], updatedCounFields[currentIndex + 1]] =
                [updatedCounFields[currentIndex + 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex+1]]=
                [updatedContryCodeValidity[currentIndex+1],updatedContryCodeValidity[currentIndex]]
                
            setEmergencyContactDetails(updatedContactDetails);
            setNewEmergencyCountycodes(updatedCounFields);
            setNewEmergencyValidCountrycode(updatedContryCodeValidity)
        }
    };
    
    const handleMoveUpEmergencyContact = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...emergencyContactDetails];
        const updatedCounFields = [...newEmergencyCountycodes];
        const updatedContryCodeValidity = [...newEmergencyValidCountrycode]
        
        if (currentIndex > 0) {
            // Swap current element with the previous one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex - 1]] =
                [updatedContactDetails[currentIndex - 1], updatedContactDetails[currentIndex]];
    
            [updatedCounFields[currentIndex], updatedCounFields[currentIndex - 1]] =
                [updatedCounFields[currentIndex - 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex-1]]=
                [updatedContryCodeValidity[currentIndex-1],updatedContryCodeValidity[currentIndex]]
            
            setEmergencyContactDetails(updatedContactDetails);
            setNewEmergencyCountycodes(updatedCounFields);
            setNewEmergencyValidCountrycode(updatedContryCodeValidity)
            
        }
    };
    const handleClearEmergencyContact = (index) => {
        const updatedEmergencyContactDetails = [...emergencyContactDetails];
        const updatedEmergencyContactcountryCode = [...newEmergencyCountycodes];
        
        // Clear the fields in the copied state
        updatedEmergencyContactDetails[index].emergency_contact_name = '';
        updatedEmergencyContactDetails[index].mobile_number = '';
        handleEmergencyPhoneLayerValidation(index,true,'mobile_number')
        // Update the state with the modified array
        setEmergencyContactDetails(updatedEmergencyContactDetails);
    
        if (edit) {
            const emergencyContactDetailsres = data[0]?.contacts?.length > 0 ? data[0]?.contacts : [{}];
            setNewEmergencyCountycodes(
                emergencyContactDetailsres?.map((contact) => ({
                    mobile_number: contact.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
        } else {
            setNewEmergencyCountycodes(updatedEmergencyContactcountryCode);
        }
    };
    
    
    const handleClearCaseManagerContact = (index) => {
        const updatedCaseManagersContactDetails = [...caseManagersContactDetails];
        const updatedCaseManagerContactcountryCode = [...newCaseMangerCountycodes]

        updatedCaseManagersContactDetails[index].case_manager_name = ''; // or set to your desired empty value
        updatedCaseManagersContactDetails[index].mobile_number = ''; // or set to your desired empty value
        handlePhoneLayerValidation(index,true,'mobile_number')
        // Update the state with the modified array
        setcaseManagersContactDetails(updatedCaseManagersContactDetails);
        if(edit){
            const caseManagerDetails=data[0]?.case_managers?.length>0?data[0]?.case_managers: [{}] ;
            setNewCaseMangerCountycodes(
                caseManagerDetails?.map((manager) => ({
                    mobile_number: manager.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );        }
        else{
            setNewCaseMangerCountycodes(updatedCaseManagerContactcountryCode);
        }
    };


    const handleDeleteAssociatedOrganization = (item, index) => {
        
        setSelectedRowtoDelete(item)
        setDeleteModel(true)
    }

    


    useEffect(()=>{
        if(data!==undefined){
            // setMonitorUserId(data?.user_id)
            
            setStatusToggle(data[0]?.status === "inactive" ? false : true)

            
            setSkip(true)
        }
        if(data!==undefined){
          
        
            data[0]?.organization_id!==""&&data[0]?.organization_id!==undefined&&handleFetchSubdivision({"organization_id":data[0]?.organization_id,"organization_name":data[0]?.organization_name})
            data[0]?.organization_id!==""&&data[0]?.organization_id!==undefined&&handleSelectionSubdivision({"subdivision_id":data[0]?.subdivision_id,
                "sub_division_name":data[0]?.subdivision_name,"number_of_readings":data[0]?.defaultReadings?.number_of_readings===""?"0":data[0]?.defaultReadings?.number_of_readings,"number_of_time_periods":data[0]?.defaultReadings?.number_of_time_periods===""?"0":data[0]?.defaultReadings?.number_of_time_periods,"time_period":data[0]?.defaultReadings?.time_period},data[0]?.organization_id,"fromuseeffect")
            setIsMonitorPopupClick(true)
            monitorTrigger(data[0]?.patient_id)
            providerTrigger(`${data[0]?.patient_id}${userType==='corporate-user'?'&action=view':''}`)
            observerTrigger(data[0]?.patient_id)

            
        }
        if (data && edit) {
            const administrativeNotes = data[0]?.notes || []; // Ensure notes array exists
            const notes = administrativeNotes
                .filter(item => item.note_type === "administrative-note") // Filter out only administrative notes
                .map(item => ({
                    administrative_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                    patient_id:item.patient_id || '',
                }));
        
            setAdministrativeNotes(notes);
        }
        
        if (data && edit) {
            const medicalNotes = data[0]?.notes || []; // Ensure notes array exists
            const medicalnote = medicalNotes
                .filter(item => item.note_type === "medical-note") // Filter out only administrative notes
                .map(item => ({
                    medical_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                }));
        
            setMedicalNotes(medicalnote);
        }
        if(data&& edit){
            setCountryCodeVal(data[0]?.country_code1?.split('+')[1])
            setCountryCodeVal2(data[0]?.country_code2?.split('+')[1])
            const caseManagerDetails=data[0]?.case_managers?.length>0?data[0]?.case_managers: [{}] ;
            setcaseManagersContactDetails(
                caseManagerDetails?.map((manager) => ({
                    case_manager_name: manager.name || '',
                    mobile_number: manager.contact_number || '',
                    uid:manager?.uid

                }))
            );
            setNewCaseMangerCountycodes(
                caseManagerDetails?.map((manager) => ({
                    mobile_number: manager.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewCaseMangerValidCountrycode(
                caseManagerDetails?.map(() => ({
                    mobile_number: true,
                }))
            ); 

            const emergencyContactDetailsres=data[0]?.contacts?.length>0?data[0]?.contacts: [{}];
            setEmergencyContactDetails(
                emergencyContactDetailsres?.map((contact) => ({
                    emergency_contact_name: contact.name || '',
                    mobile_number: contact.contact_number || '',
                    uid:contact?.uid
                }))
            );
            setNewEmergencyCountycodes(
                emergencyContactDetailsres?.map((contact) => ({
                    mobile_number: contact.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewEmergencyValidCountrycode(
                emergencyContactDetailsres?.map(() => ({
                    mobile_number: true,
                }))
            ); 
        }
    },[data,setNewCaseMangerCountycodes,setSelectedOrganizationName,setAddPatientBasicDetails,setNewEmergencyValidCountrycode,setNewEmergencyValidCountrycode,setEmergencyContactDetails,setNewCaseMangerValidCountrycode,setNewCaseMangerCountycodes])

   
    
    const redioButtonGender = ["Male", "Female", "Other"]
    const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(data?.created_at).format(dateformat)

    const handleOnVerifyEmail=async()=>{           
        if(addPatientDetails?.email_addr?.trim()!==""&&validateEmail(addPatientDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
               
        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body={}
            body={
                "user_type":"patient",
                "email_address": addPatientDetails.email_addr.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes=await updateEmail({id,body})

            if(emailVerifyRes?.error?.data?.message==="Email Address must be a valid email address"){
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true
                })) 
                setEmailButtonLoading(false)
            }
            else if(emailVerifyRes?.error?.data?.message){
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":false
                })) 
                setEmailButtonLoading(false)
            }
            else{
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)   
                setEmailVeriedButton(false)
            }
            setIsDisableCancel(true)
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }


    const handleConformationClickStatus = () => {
        setEmptyArea(false)
        setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationStateStatus(false);
    }
    // status change 
    const handleOnCLickChangeStatus = async(e) => {
        // useDispatch(handleIsAPICall(true))
        if(statusToggle===false&& textAreaMsg.trim()===""){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyArea(true)
            return;
        }
        try {
            let body = { }
            if(statusToggle===false){
                body={
                    "user_names": [addPatientDetails?.user_name],
                    "status":"inactive",
                    "note" : textAreaMsg 
                } 
            }
            else{
                body={
                    "user_names": [addPatientDetails?.user_name],
                    "status":"active",
                    "note":''
                } 
            }
            
            setLoadingStatus(true)
            
            const activationRes=await editPatient({body})
            
            setLoadingStatus(false)
            
            if(activationRes.error){
                setToastErrorMessage('Something went wrong. Please try again')
            }else{
                setToastmessage(`Patient ${statusToggle===true?"activated":"deactivated"} successfully`);
                
            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');
           
        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  
   
    return (
        <>
            <div>
                {edit&&isMonitorPopupClick&&((monitorResult.status !== "fulfilled" && monitorResult.status !== "rejected") || (monitorResult === undefined && monitorResult.status !== "fulfilled" && monitorResult.status !== "rejected")) ?
                    <CustomOverLay Active text="Loading basic details..." classKey={` left-0 top-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? ('opened_sidebar_device_patient') : 'sidebar_basic_details'}`} />:
                    <div>
                        <div className='mb-6'>
                            <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-5'>Basic Details</h1>
                            <div className='flex flex-wrap -mx-3'>
                                {edit&& <div className={`w-1/3 px-3 mb-[22px]`}>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Username*"} 
                                            placeholder={"Enter username"}
                                            id={"user_name"}
                                            htmlFor={"Admin_Username"}
                                            value={addPatientDetails?.user_name}
                                            emailError={emailError.username_error}
                                            usernameError={usernameError}
                                            emptyField={emptyField&&addPatientDetails?.user_name?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            disabled={true}
                                        />
                                        {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                    </div>
                                </div>}
                                {!edit && 
                                <div className={`w-1/3 px-3 mb-[22px]`}>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Username*"} 
                                            placeholder={"Enter username"}
                                            id={"user_name"}
                                            data-testid={"username"}
                                            htmlFor={"user_name"}
                                            value={addPatientDetails?.user_name}
                                            emailError={emailError.username_error}
                                            usernameError={usernameError}
                                            emptyField={emptyField&&addPatientDetails?.user_name?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                        {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                    </div>
                                </div>
                                }
                                <div className={`w-2/3 px-3 mb-[22px]`}>
                                    <div className='w-full'>
                                        <p className="text-xs font-semibold text-[#000] mb-1.5">Manage Active Alerts</p>
                                        <div className='flex flex-wrap gap-x-8 gap-y-2'>
                                            <div className="status custom-toggle flex items-center">
                                                <label className="switch" style={{marginRight: '10px'}}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={()=>{
                                                            setPatientSmsAlert(!patientSmsAlert)
                                                            setIsAnyFieldFilled(true)
                                                        }}
                                                        checked={patientSmsAlert}
                                                        disabled={!addPatientDetails?.mobile_number || addPatientDetails?.mobile_number?.trim() === ""}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <p className="text-sm font-normal text-[#000000]">SMS</p>
                                            </div>
                                            <div className="status custom-toggle flex items-center">
                                                <label className="switch" style={{marginRight: '10px'}}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={()=>{
                                                            setPatientEmailAlert(!patientEmailAlert)
                                                            setIsAnyFieldFilled(true)
                                                        }}
                                                        checked={patientEmailAlert}
                                                        disabled={!(edit ? addPatientDetails?.email_addr : addPatientDetails?.user_name) || (edit ? addPatientDetails?.email_addr : addPatientDetails?.user_name)?.trim() === ""}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <p className="text-sm font-normal text-[#000000]">Email</p>
                                            </div>
                                            <div className="status custom-toggle flex items-center">
                                                <label className="switch" style={{marginRight: '10px'}}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={()=>{
                                                            setPatientMissedReading(!patientMissedReading)
                                                            setIsAnyFieldFilled(true)
                                                        }}
                                                        checked={patientMissedReading}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <p className="text-sm font-normal text-[#000000]">Missed Reading</p>
                                            </div>
                                            <div className="status custom-toggle flex items-center">
                                                <label className="switch" style={{marginRight: '10px'}}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={()=>{
                                                            setPatientReadingReceived(!patientReadingReceived)
                                                            setIsAnyFieldFilled(true)
                                                        }}
                                                        checked={patientReadingReceived}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <p className="text-sm font-normal text-[#000000]">Reading Received</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap -mx-3'>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"First Name*"} 
                                            placeholder={"Enter first name"}
                                            id={"first_name"}
                                            data-testid={"first_name"}
                                            htmlFor={"first_name"}
                                            value={addPatientDetails?.first_name}
                                            emptyField={emptyField&&addPatientDetails?.first_name?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Middle Name"} 
                                            placeholder={"Enter middle name"}
                                            id={"middle_name"}
                                            htmlFor={"middle_name"}
                                            value={addPatientDetails.middle_name}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Last Name*"} 
                                            placeholder={"Enter last name"}
                                            id={"last_name"}
                                            data-testid={"last_name"}
                                            htmlFor={"last_name"}
                                            value={addPatientDetails.last_name}
                                            emptyField={emptyField&&addPatientDetails?.last_name?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                {!edit&&
                                <div className={`w-1/3 px-3 mb-[22px]`}>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Email Address*"} 
                                            placeholder={"Enter email address"}
                                            id={"email_addr"}
                                            data-testid={"email_address"}
                                            htmlFor={"email_addr"}
                                            value={addPatientDetails?.user_name}
                                            emptyField={emptyField&&addPatientDetails?.user_name?.trim()===""}
                                            emailError={emailError.email_error}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            disabled={true}
                                        />
                                        {emailError.email_error && <ErrorMessage error  message={"Invalid email address"}/>}
                                    </div>
                                </div>
                                }

                                {edit&&<>
                                    <div className={`w-1/3 px-3 mb-[22px]`}>
                                        <div className='w-full'>
                                            <InputBox
                                                label={"Email Address*"} 
                                                placeholder={"Enter email address"}
                                                id={"email_addr"}
                                                data-testid={"email_address"}
                                                htmlFor={"email_addr"}
                                                value={addPatientDetails?.email_addr}
                                                emptyField={emptyField&&addPatientDetails?.email_addr?.trim()===""}
                                                emailError={emailError.email_error}
                                                handleOnChangeInput={handleOnChangeUserDetails}
                                            />
                                            {emailError.email_error && <ErrorMessage error  message={emailError?.text&&"Invalid email address"}/>}
                                        </div>
                                    </div>

                                    {( (data[0]?.email_address !== addPatientDetails?.email_addr)) && 
                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                        <button type='button'
                                            id="verify"
                                            onClick={() => handleOnVerifyEmail()}
                                            disabled={emailButtonLoading || !emailVefiedButton || addPatientDetails?.email_addr?.trim()===""}
                                            className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                            {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                        </button>
                                    </div>
                                    }
                                                
                                    {((data[0]?.email_address === addPatientDetails?.email_addr)) && 
                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3`}>
                                        <button type='button'
                                            id="verified"
                                            className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                        bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                            <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                <img src="/images/success_toast.svg" alt="icon" loading='lazy'  className='w-3.5 h-3.5' decoding='async' />
                                            </span>
                                            Verified
                                        </button>
                                    </div>
                                    }
                        
                                </>}
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                                        
                                        <PhoneNumberValidator
                                            label={"Mobile Number"}
                                            placeholder={"Enter mobile number"}
                                            id={"mobile_number"}
                                            htmlFor={"mobile_number"}
                                            value={addPatientDetails.mobile_number}
                                            emptyField={false}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            isCode={true}
                                            countryCodeList={phoneCodeArray}
                                            country_code={country_code}
                                            countryCodeVal={countryCodeVal2}
                                            isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                            setCountryCodeVal={setCountryCodeVal2}
                                            submitSelected={submitSelected}
                                            isPatient={true}
                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <PhoneNumberValidator
                                            label={"Main Number*"} 
                                            placeholder={"Enter main number"}
                                            id={"main_number"}
                                            htmlFor={"main_number"}
                                            value={addPatientDetails.main_number}
                                            emptyField={emptyField&&addPatientDetails?.main_number?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            isCode={true}
                                            countryCodeList={phoneCodeArray}
                                            country_code={country_code}
                                            countryCodeVal={countryCodeVal}
                                            setCountryCodeVal={setCountryCodeVal}
                                            isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                            submitSelected={submitSelected}
                                            isPatient={true}
                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                        />
                                    </div>
                                </div>
                                {edit&&<div className='w-1/3 px-[18px] mt-[37px] mb-[35px]'>
                                    <div className='w-full'>
                                        <div  className="status custom-toggle flex items-center ">
                                            <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                Status
                                            </p> 
                                            <label className="switch" style={{marginLeft: '10px'}}>
                                                <input type="checkbox"  onChange={(e)=>{
                                                    setStatusToggle(!statusToggle),setConfirmationStateStatus(true)
                                                }} checked={statusToggle} /><span id="user_status" className="slider round"></span>
                                            </label>
                                            <p id='status' className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                                {statusToggle?'Active':'Inactive'}
                                            </p> 
                                        </div>
                                    </div>
                                </div> }
                               
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='flex -mx-3'>
                                        <div className='w-2/3 px-3'>
                                            <div className='w-full'>
                                                <CustomDatePicker
                                                    id={"date_of_birth"}
                                                    setdateError={()=>{}}
                                                    classKey={`border ${emptyField&&addPatientDetails?.date_of_birth==="" ? 'border-red-500' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                                                    format="MMM DD, YYYY"
                                                    // state={filterValues}
                                                    placeholder={"Select Date"}
                                                    label={"Date of Birth*"}
                                                    termkey={addPatientDetails?.date_of_birth}
                                                    handleSelect={handleSelectDate}
                                                    disabledFutureDate={true}
                                                                    
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-3'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Age"} 
                                                    placeholder={"Age"}
                                                    id={"age"}
                                                    htmlFor={"age"}
                                                    value={addPatientDetails.age}
                                                    disabled={true}
                                                    handleOnChangeInput={handleSelectDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-2/3 px-3 mb-[22px]'>
                                    {/* gender */}
                                    <div className='w-full'>
                                        <p className='text-sm font-semibold text-[#000000] pb-1.5'>Gender*</p>
                                        <div className='flex items-center'>
                                            {redioButtonGender.map((item) =>
                                                (<div className="p-2" key={item}>
                                                    <div className="relative custom-radioBlue flex items-center">
                                                        <input id={item} data_testid={"gender"} type="radio" name="default-radio" checked={addPatientDetails?.gender === item} onChange={() => { handleCheckBox("gender", item) }} />
                                                        <label htmlFor={item} className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                            {item}
                                                        </label>
                                                    </div>
                                                </div>))}
                                        </div>
                                    </div>
                                </div>
                                <div className='w-full px-3 mb-[35px]'>
                                    <div className='w-3/4'>
                                        <TextArea label={'Address'}
                                            htmlFor={'address'}
                                            id={'address'}
                                            value={addPatientDetails?.address}
                                            placeholder={'Enter Address'}
                                            emptyField={false}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Primary Identifier*"} 
                                            placeholder={"Enter primary identifier"}
                                            id={"primary_identifier"}
                                            htmlFor={"primary_identifier"}
                                            value={addPatientDetails.primary_identifier}
                                            emptyField={emptyField&&addPatientDetails?.primary_identifier?.trim()===""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Secondary Identifier"} 
                                            placeholder={"Enter secondary identifier "}
                                            id={"secondary_identifier"}
                                            htmlFor={"secondary_identifier"}
                                            value={addPatientDetails.secondary_identifier}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='xl:w-[80%] w-full'>
                                        <CustomDatePicker
                                            id={"onboarding_date"}
                                            classKey={`border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                                            format="MMM DD, YYYY"
                                            setdateError={()=>{}}
                                            // state={filterValues}
                                            placeholder={"Select Date"}
                                            label={"Onboarding Date"}
                                            termkey={addPatientDetails?.onboarding_date}
                                            handleSelect={handleSelectDate}
                                                                
                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='flex -mx-3'>
                                        <div className='px-3 w-1/2'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Weight(kg)*"} 
                                                    placeholder={"Enter weight"}
                                                    id={"weightKg"}
                                                    data-testid={"weight_in_kg"}
                                                    htmlFor={"weightKg"}
                                                    value={addPatientDetails.weightKg}
                                                    emptyField={emptyField&&addPatientDetails?.weightKg===""}
                                                    handleOnChangeInput={handleOnChangeUserDetails}
                                                />
                                            </div>
                                        </div>
                                        <div className='px-3 w-1/2'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Weight(lbs)*"} 
                                                    placeholder={"Enter weight"}
                                                    id={"weightlbs"}
                                                    htmlFor={"weightlbs"}
                                                    value={addPatientDetails.weightlbs}
                                                    emptyField={emptyField&&addPatientDetails?.weightlbs===""}
                                                    handleOnChangeInput={handleOnChangeUserDetails}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <Dropdown
                                            label={"Patient Status*"}
                                            id={"patient_status"}
                                            placeholder={addPatientDetails.patient_status.length > 0 ? '' : 'Select patient status'}
                                            data_testid={"patient_status"}
                                            value={addPatientDetails?.patient_status}
                                            options={['At Home','Hospitalized','Away','Deceased']}
                                            emptyField={emptyField&&addPatientDetails.patient_status.length===0}
                                            handleOnChangeInput={handleOnChangeUserDetails}                                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3 mb-[22px]'>
                                    <div className='w-full'>
                                        <TimeZoneDropdown
                                            label={`Time Zone*`}
                                            placeholder={'Select patient time zone'}
                                            id={'patient_timezone'}
                                            disabled={false}
                                            selectedTimezone={selectedTimeZone}
                                            setisOpenTimeZone={setisOpenTimeZone}
                                            isOpenTimeZone={isOpenTimeZone}
                                            handleSelectionTimezone={handleSelectionTimezone}
                                            setSelectedTimezone={setSelectedTimezone}
                                            setSearchValue={setSearchTimeZoneValue}
                                            searchValue={searchTimeZoneValue}
                                            emptyField={emptyField && selectedTimeZone.length === 0}
                                            timezones={timezones}
                                            setTimezones={setTimezones}
                                            filteredTimezones={filteredTimezones}
                                            setFilteredTimezones={setFilteredTimezones}
                                        />
                                    </div>

                                </div>
                                <div className={`xl:w-1/3 w-2/3 px-3 mb-[22px]`}>
                                    <div className='w-full'>
                                        <p className='text-sm font-semibold text-[#000000] mb-1.5'>Monitoring Status*</p>
                                        <div className='flex items-center'>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input id="monitored" type="radio" name="default-radio1" checked={addPatientDetails?.monitor_status} onChange={()=>handleOnChangeUserDetails("monitor_status",false)}/>
                                                    <label htmlFor="monitored" className={`text-base font-normal ${addPatientDetails?.monitor_status ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                        Monitored
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center" >
                                                    <input id="not_monitored"  type="radio" name="default-radio1" checked={!addPatientDetails?.monitor_status} onChange={()=>handleOnChangeUserDetails("monitor_status",true)}/>
                                                    <label htmlFor="not_monitored" className={`text-base font-normal ${!addPatientDetails?.monitor_status ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                        Not Monitored 
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                                {edit &&
                                <div className='xl:w-1/3 w-1/3 px-3 mb-[22px]'>
                                    <div className='xl:w-[80%] w-full'>
                                        <CustomDatePicker
                                            id={"monitor_cycle_start_date"}
                                            classKey={`border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                                            format="MMM DD, YYYY"
                                            setdateError={()=>{}}
                                            // state={filterValues}
                                            placeholder={"Select Date"}
                                            label={"Monitoring Cycle Start Date"}
                                            termkey={addPatientDetails?.monitor_cycle_start_date}
                                            handleSelect={handleSelectDate}
                                                                    
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
          
                        <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>{`Minimun Readings Conditions (By default ${selectedSubdivReadings?.no_of_readings} readings in ${selectedSubdivReadings?.no_of_days} ${selectedSubdivReadings?.time_period})`}</h1> 
                        <div className='bg-[#E5F3F3] mb-5 mt-4 rounded-lg'>
                            <div className='flex p-5'>
                                <div className='w-1/4 mr-[24px]'>
                                    <InputBox
                                        label={"Readings*"} 
                                        id={"no_of_readings"}
                                        htmlFor={"no_of_readings"}
                                        placeholder={'Enter number of readings'}
                                        value={(addPatientDetails.number_of_readings === null|| addPatientDetails.number_of_readings === "")? "" :addPatientDetails.number_of_readings}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        emptyField={emptyField && addPatientDetails.number_of_readings===""||addPatientDetails.number_of_readings === null }
                                    />
                                                        
                                </div>
                                <div className='w-1/4 mr-[24px]'>
                                    <InputBox
                                        label={"Number of Days*"} 
                                        id={"no_of_time_period2"}
                                        htmlFor={"no_of_time_period2"}
                                        placeholder={"Enter number of days"}
                                        value={ (addPatientDetails.number_of_time_periods === null || addPatientDetails.number_of_time_periods === "" )? "":addPatientDetails.number_of_time_periods}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        emptyField={emptyField && addPatientDetails.number_of_time_periods===""||addPatientDetails.number_of_time_periods === null}
                                                           
                                    />
                                </div>
                                <div className='w-1/4'>  
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_period"}
                                        placeholder={''}
                                        value={addPatientDetails.time_period ||'Day(s)'}
                                        options={['Day(s)','Week(s)','Month(s)','Calendar Month(s)']}
                                        emptyField={emptyField&&addPatientDetails.time_period===''}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='mb-5'>
                            <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>Additional Contact Details</h1>
                            <div>
                                <h1 className='pb-3 text-base font-normal text-[#000000] w-fit pt-6 relative border_bottom_sideRounded mb-3'>Emergency Contact Details (First entry is highest priority)</h1>
                                {emergencyContactDetails?.map((field,index)=>(<Fragment key={index}>
                                    <div className='flex -mx-3 mb-[22px]'>
                                        <div className='w-1/6 px-3 pt-[22px]'>
                                            <div className='w-full rounded-lg border border-[#C5C9DA] flex'>
                                                <button
                                                    className='disabled:opacity-50 w-1/2 pl-2 py-[10px]'
                                                    onClick={() => handleMoveDownEmergencyContact(index)}
                                                    disabled={index === emergencyContactDetails.length - 1}
                                                                    
                                                >
                                                    <img src="/images/arrow-down.svg" alt="icon" className='mx-auto' />
                                                </button>


                                                <button
                                                    className='disabled:opacity-50 w-1/2 pr-2 py-[10px]'
                                                    onClick={() => handleMoveUpEmergencyContact(index)}
                                                    disabled={index === 0}
                                                >
                                                    <img src="/images/arrow-down.svg" alt="icon" className='rotate-[180deg] mx-auto' />
                                                </button>

                                            </div>
                                        </div>
                                        <div className='w-2/6 px-3'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Name"} 
                                                    maxLength={60}
                                                    placeholder={"Enter name"}
                                                    id={"emergency_contact_name"}
                                                    htmlFor={"emergency_contact_name"}
                                                    value={emergencyContactDetails[index].emergency_contact_name}
                                                    handleOnChangeInput={handleOnChangeEmergencyContactDetails}
                                                    index={index}
                                                />
                                            </div>

                                        </div>
                                        <div className='w-2/6 px-3'>
                                            <div className='w-full'>
                                                                
                                                <PhoneNumberValidator
                                                    label={"Mobile Number"}
                                                    placeholder={"Enter mobile number"}
                                                    id={"mobile_number"}
                                                    data_testid="emergencyContact_mobile_number"
                                                    htmlFor={"Admin_Mobile_Number"}
                                                    value={emergencyContactDetails[index]?.mobile_number}
                                                    emptyField={false}
                                                    handleOnChangeInput={handleOnChangeEmergencyContactDetails}
                                                    handleCOuntryCodeForObj={handleEmergencyCOuntryCodeForObj}
                                                    isCode={true}
                                                    index={index}
                                                    countryCodeList={phoneCodeArray}
                                                    country_code={country_code}
                                                    countryCodeVal={newEmergencyCountycodes[index]?.mobile_number}
                                                    isPhoneNumberValid={newEmergencyValidCountrycode[index]?.mobile_number}
                                                    setIsPhoneNumberValid={handleEmergencyPhoneLayerValidation}
                                                    setCountryCodeVal={setNewEmergencyCountycodes}
                                                    submitSelected={submitSelected}
                                                    isOnType={isOnType}
                                                    maxLength={20}
                                                    setIsOnType={setIsOnType}
                                                    isPatient={true}
                                                    //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                />
                                            </div>

                                        </div>
                                        <div className='w-1/6 px-[18px] flex'>
                                            {emergencyContactDetails?.length === 1 && (
                                                <div className='flex'>
                                                    <div className="relative pt-[34px]">
                                                        <button className='clear_contact'
                                                            onClick={() => handleClearEmergencyContact(index)}
                                                        >
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/red-x-line-icon.svg"
                                                                    alt="clear-icon"
                                                                    className='w-[27px]'
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-9px] clear_contact_text opacity-0'>
                                                            Clear
                                                        </p>
                                                    </div>
                                                    <div className='relative ml-4'>
                                                        <button onClick={handleAddEmergencyContact} type='button' className='pt-[37px] add_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/add-plus-red.svg"
                                                                    alt="add-icon"
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                            Add
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {emergencyContactDetails?.length > 1 && (
                                                <>
                                                    {index === 0 && (
                                                        <div className="relative">
                                                            <button
                                                                onClick={() => {
                                                                    setDeleteIndex(index);
                                                                    handleEmeregencyContact();
                                                                }}
                                                                className='pt-9 delete_contact'
                                                            >
                                                                <span>
                                                                    <img
                                                                        loading='lazy'
                                                                        decoding='async'
                                                                        src="/images/deleteicon-pink.svg"
                                                                        alt="delete-icon"
                                                                    />
                                                                </span>
                                                            </button>
                                                            <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                Delete
                                                            </p>
                                                        </div>
                                                    )}
                                                    {index !== 0 && index !== emergencyContactDetails?.length - 1 && (
                                                        <div className="relative">
                                                            <button
                                                                onClick={() => {
                                                                    setDeleteIndex(index);
                                                                    handleEmeregencyContact();
                                                                }}
                                                                className='pt-9 delete_contact'
                                                            >
                                                                <span>
                                                                    <img
                                                                        loading='lazy'
                                                                        decoding='async'
                                                                        src="/images/deleteicon-pink.svg"
                                                                        alt="delete-icon"
                                                                    />
                                                                </span>
                                                            </button>
                                                            <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                Delete
                                                            </p>
                                                        </div>
                                                    )}
                                                    {index === emergencyContactDetails?.length - 1 && (
                                                        <div className='flex'>
                                                            <div className='relative'>
                                                                <button onClick={() => {setDeleteIndex(index);handleEmeregencyContact()}} className='pt-9 delete_contact'>
                                                                    <span>
                                                                        <img
                                                                            loading='lazy'
                                                                            decoding='async'
                                                                            src="/images/deleteicon-pink.svg"
                                                                            alt="delete-icon"
                                                                        />
                                                                    </span>
                                                                </button>
                                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                    Delete
                                                                </p>
                                                            </div>
                                                            <div className='relative ml-4'>
                                                                <button onClick={handleAddEmergencyContact} type='button' className='pt-[37px] add_contact'>
                                                                    <span>
                                                                        <img
                                                                            loading='lazy'
                                                                            decoding='async'
                                                                            src="/images/add-plus-red.svg"
                                                                            alt="add-icon"
                                                                        />
                                                                    </span>
                                                                </button>
                                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                                    Add
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Fragment>))}
                            </div>
                            <div>
                                <h1 className='pb-3 text-base font-normal text-[#000000] w-fit pt-6 relative border_bottom_sideRounded mb-3'>Case Manager Contact Details (First entry is highest priority)</h1>
                                {caseManagersContactDetails?.map((field,index)=>(<Fragment key={index}>
                                    <div className='flex -mx-3 mb-[22px]'>
                                        <div className='w-1/6 px-3 pt-[22px]'>
                                            <div className='w-full rounded-lg border border-[#C5C9DA] flex'>
                                                <button
                                                    className='disabled:opacity-50 w-1/2 pl-2 py-[10px]'
                                                    onClick={() => handleMoveDown(index)}
                                                    disabled={index === caseManagersContactDetails.length - 1}
                                                                    
                                                >
                                                    <img src="/images/arrow-down.svg" alt="icon" className='mx-auto' />
                                                </button>
                                                <button
                                                    className='disabled:opacity-50 w-1/2 pr-2 py-[10px]'
                                                    onClick={() => handleMoveUp(index)}
                                                    disabled={index === 0}
                                                >
                                                    <img src="/images/arrow-down.svg" alt="icon" className='rotate-[180deg] mx-auto' />
                                                </button>

                                            </div>
                                        </div>
                                        <div className='w-2/6 px-3'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Name"} 
                                                    maxLength={60}
                                                    placeholder={"Enter name"}
                                                    id={"case_manager_name"}
                                                    htmlFor={"case_manager_name"}
                                                    value={caseManagersContactDetails[index].case_manager_name}
                                                    handleOnChangeInput={handleOnChangeCaseMangerContact}
                                                    index={index}
                                                />
                                            </div>

                                        </div>
                                        <div className='w-2/6 px-3'>
                                            <div className='w-full'>
                                                                
                                                <PhoneNumberValidator
                                                    label={"Mobile Number"}
                                                    placeholder={"Enter mobile number"}
                                                    id={"mobile_number"}
                                                    data_testid="caseManager_mobile_number"
                                                    htmlFor={"Admin_Mobile_Number"}
                                                    value={caseManagersContactDetails[index]?.mobile_number}
                                                    emptyField={false}
                                                    handleOnChangeInput={handleOnChangeCaseMangerContact}
                                                    handleCOuntryCodeForObj={handleCOuntryCodeForObj}
                                                    isCode={true}
                                                    index={index}
                                                    countryCodeList={phoneCodeArray}
                                                    country_code={country_code}
                                                    countryCodeVal={newCaseMangerCountycodes[index]?.mobile_number}
                                                    isPhoneNumberValid={newCaseMangerValidCountrycode[index]?.mobile_number}
                                                    setIsPhoneNumberValid={handlePhoneLayerValidation}
                                                    setCountryCodeVal={setNewCaseMangerCountycodes}
                                                    submitSelected={submitSelected}
                                                    isOnType={isOnType}
                                                    setIsOnType={setIsOnType}
                                                    maxLength={20}
                                                    isPatient={true}
                                                />
                                            </div>

                                        </div>
                                        <div className='w-1/6 px-[18px] flex'>
                                            {caseManagersContactDetails?.length === 1 && (
                                                <div className='flex'>
                                                    <div className="relative pt-[34px]">
                                                        <button className='clear_contact'
                                                            onClick={() => handleClearCaseManagerContact(index)}
                                                        >
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/red-x-line-icon.svg"
                                                                    alt="clear-icon"
                                                                    className='w-[27px]'
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-9px] clear_contact_text opacity-0'>
                                                            Clear
                                                        </p>
                                                    </div>
                                                    <div className='relative ml-4'>
                                                        <button onClick={handleAddCaseContact} type='button' className='pt-[37px] add_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/add-plus-red.svg"
                                                                    alt="add-icon"
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                            Add
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {caseManagersContactDetails?.length > 1 && (
                                                <>
                                                    {index === 0 && (
                                                        <div className="relative">
                                                            <button
                                                                onClick={() => {
                                                                    setDeleteIndex(index);
                                                                    handleRemoveCaseContact();
                                                                }}
                                                                className='pt-9 delete_contact'
                                                            >
                                                                <span>
                                                                    <img
                                                                        loading='lazy'
                                                                        decoding='async'
                                                                        src="/images/deleteicon-pink.svg"
                                                                        alt="delete-icon"
                                                                    />
                                                                </span>
                                                            </button>
                                                            <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                Delete
                                                            </p>
                                                        </div>
                                                    )}
                                                    {index !== 0 && index !== caseManagersContactDetails?.length - 1 && (
                                                        <div className="relative">
                                                            <button
                                                                onClick={() => {
                                                                    setDeleteIndex(index);
                                                                    handleRemoveCaseContact();
                                                                }}
                                                                className='pt-9 delete_contact'
                                                            >
                                                                <span>
                                                                    <img
                                                                        loading='lazy'
                                                                        decoding='async'
                                                                        src="/images/deleteicon-pink.svg"
                                                                        alt="delete-icon"
                                                                    />
                                                                </span>
                                                            </button>
                                                            <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                Delete
                                                            </p>
                                                        </div>
                                                    )}
                                                    {index === caseManagersContactDetails?.length - 1 && (
                                                        <div className='flex'>
                                                            <div className='relative'>
                                                                <button onClick={() => {setDeleteIndex(index);handleRemoveCaseContact()}} className='pt-9 delete_contact'>
                                                                    <span>
                                                                        <img
                                                                            loading='lazy'
                                                                            decoding='async'
                                                                            src="/images/deleteicon-pink.svg"
                                                                            alt="delete-icon"
                                                                        />
                                                                    </span>
                                                                </button>
                                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                                    Delete
                                                                </p>
                                                            </div>
                                                            <div className='relative ml-4'>
                                                                <button onClick={handleAddCaseContact} type='button' className='pt-[37px] add_contact'>
                                                                    <span>
                                                                        <img
                                                                            loading='lazy'
                                                                            decoding='async'
                                                                            src="/images/add-plus-red.svg"
                                                                            alt="add-icon"
                                                                        />
                                                                    </span>
                                                                </button>
                                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                                    Add
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Fragment>))}
                            </div>
                        </div>
               
                        {<div className='mb-5 mt-10'>
                            <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot'>{edit?'Organizational Assignment and User Associations':'Organizational Assignment'}</h1>
                            <div className='flex w-full mb-5 mt-5'>
                                <div className='xl:w-1/3 lg:w-1/2 px[18px]'>
                                    <OrganizationDropdownWithSearch
                                        label={"Organization Name*"}
                                        organizationListSearch={organizationListSearch}
                                        id={`organization_name`}
                                        placeholder={'Select organization name'}
                                        disabled={monitorResult?.data?.data?.length>0||providerResult?.data?.data?.length>0||observerResult?.data?.data?.length>0}
                                        value={organizationListSearch?.search || ''}
                                        organizationData={organizationData}
                                        organizationFetching={organizationFetching}
                                        handleOrganizationListSearch={handleOrganizationListSearch}
                                        handleFetchSubdivision={handleFetchSubdivision}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setisOpen={setisOpen}
                                        isOpen={isOpen}
                                        emptyField={emptyField&&selectedOrganizationName?.organization_id===''}
                                        optionId={"option_organization_name"}
                                        addObserver={true}
                                        isMonitor={true}
                                                    
                                    />
                                </div>
                                <div className='xl:w-1/3 lg:w-1/2  px-[18px]'>
                                    <SubdivisionDropdownWithSearch
                                        label={"Sub Division Name*"}
                                        placeholder={'Select sub division name'}
                                        id={`sub_division_name`}
                                        subdivisionData={subresult?.data}
                                        value={selectedOrganizationName.sub_division_name || ''}
                                        disabled={selectedOrganizationName.organization_name === '' || selectedOrganizationName.organization_name === undefined || monitorResult?.data?.data?.length>0 ||providerResult?.data?.data?.length>0||observerResult?.data?.data?.length? true : false}
                                        handleSubdivisionListSearch={handleSubdivisionListSearch}
                                        handleAddAssociation={()=>{}}
                                        selectedOrganizationName={selectedOrganizationName}
                                        selectedSubdivisionName={selectedSubdivisionName}
                                        setisOpensub={setisOpensub}
                                        isOpensub={isOpensub}
                                        emptyField={selectedSubdivisionId===""&&emptyField}
                                        handleSelectionSubdivision={handleSelectionSubdivision}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        subdivisionloadingstatus={subresult}
                                        addObserver={true}
                                        isMonitor={true}

                                    />
                                </div>
                            </div>  
                            {edit&&<div className='w-full mb-5 mt-5 relative'>
                                <p className='pt-2.5 min-w-fit text-base font-semibold text-[#972E4C] '>Monitor Users List</p>
                                <div className='flex justify-between'>
                                    <div className='xl:w-1/3 lg:w-1/2 px[18px] pt-4'>
                                        <MonitorsDropdownwithSearch
                                            label={""}
                                            id={`monitor_users`}
                                            placeholder={'Select monitor users'}
                                            disabled={selectedOrganizationName.organization_id===''||selectedSubdivisionId===''||monitorResult?.isFetching}
                                            data={monitorDataList}
                                            setIsObserverAddOrDelete={setIsObserverAddOrDelete}
                                            setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                                            setMonitorDataList={setMonitorDataList}
                                            index={0}
                                            isMonitorsOpen={isMonitorsOpen}
                                            setIsMonitorsOpen={setIsMonitorsOpen}
                                            setLinkOrganizationModel={setLinkOrganizationModel}
                                            selectedSubdivisionId={selectedSubdivisionId}
                                            selectedOrganizationId={selectedOrganizationName?.organization_id}
                                            value={(selectedArr?.length>0)?`${selectedArr?.length} Selected`:''}
                                            monitorResult={monitorResult?.data?.data?.map((item)=>item.monitorUserData?.user_id)}
                                            isFetching={monitorDataLoading}
                                            setMonitorDataLoading={setMonitorDataLoading}
                                            noLabel={true}
                                        />
                                    </div>
                                    {isAllSelected&&monitorResult?.data?.data.length!==0&&<div className=''>
                                        <button id="action_tab" className={`self-end rounded-[15px] border border-[#972E4C] px-[16px] h-fit py-[13px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                            onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false)}}
                                            onMouseEnter={() => setIsHover(true)}
                                            onMouseLeave={() => setIsHover(false)}
                                        >
                                            {
                                                isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                                            }
                                        </button>
                                    </div>}
                                </div>
                                {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px]  absolute top-[95px] right-0 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                    <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Permission Access</li>
                                    <li>
                                        <ul>
                                            <li className='disabled:bg-[#FFF] hover:bg-[#F4F7FC] cursor-pointer' onClick={((e)=>{setPermissionAccess("view")})}>
                                                <AnimatedButton
                                                    handleClick={(e) => { setPermissionAccess("view") }}
                                                    buttonName={"View"}
                                                    disabled={(monitorResult?.data?.data?.map((item)=>item?.monitor_permission))?.every((permission)=>permission==="view")?true:false}
                                                    className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal disabled:text-[#6e6d6d] hover:text-[#008586]  text-[#000000] cursor-pointer'} `}
                                                />
                                            </li>
                                            <li className='hover:bg-[#F4F7FC] cursor-pointer' onClick={((e)=>{setPermissionAccess("monitor")})}>
                                                <AnimatedButton
                                                    handleClick={(e) => { setPermissionAccess("monitor") }}
                                                    buttonName={"Monitor"}
                                                    disabled={(monitorResult?.data?.data?.map((item)=>item?.monitor_permission))?.every((permission)=>permission==="monitor")?true:false}
                                                    className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal disabled:text-[#706a6a] hover:text-[#008586]  text-[#000000] cursor-pointer'}  `}
                                                />
                                            </li>
                                        </ul>
                                    </li>
                                </ul>}
                            </div>}
                            <div>
                                {edit?((monitorResult.status !== "fulfilled" && monitorResult.status !== "rejected") || (monitorResult === undefined && monitorResult.status !== "fulfilled" && monitorResult.status !== "rejected")) ?
                                    <CustomOverLay Active text="Loading Monitor list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_monitor_overlay3' : 'overlay-list-monitor3'}`} /> : <>
                                        <MonitoringTable
                                            monitorResult={monitorResult}
                                            setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                                            setIsObserverAddOrDelete={setIsObserverAddOrDelete}
                                            patient_id={data[0]?.patient_id}
                                            subdivision_id={selectedSubdivisionId}
                                            changeAccess={changeAccess}
                                            setChangeAccess={setChangeAccess}
                                            isAllSelected={isAllSelected}
                                            setIsAnyFieldFilled={setIsAnyFieldFilled}
                                            setIsAllSelected={setIsAllSelected}
                                            permissionAccess={permissionAccess}
                                            setPermissionAccess={setPermissionAccess}
                                            handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                            monitorSmsAlert={monitorSmsAlert}
                                            setMonitorSmsAlert={setMonitorSmsAlert}
                                            monitorEmailAlert={monitorEmailAlert}
                                            setMonitorEmailAlert={setMonitorEmailAlert}
                                            monitorMissedReading={monitorMissedReading}
                                            setMonitorMissedReading={setMonitorMissedReading}
                                        />
                                    </>:''}
                            </div>
                        </div>}
                        {edit&&<div className='w-full mb-5 mt-5'>
                            <p className='pt-2.5 min-w-fit text-base font-semibold text-[#972E4C]' id="providers-list">Providers List</p>
                            <div className='xl:w-1/3 lg:w-1/2 px[18px] pt-4'>
                                <ProvidersDropdownwithSearch
                                    label={""}
                                    id={`providers`}
                                    //placeholder={(monitorDataArr?.length<1||monitorDataArr===undefined)?'Select Monitor Users':`${monitorDataArr?.length} Selected`}
                                    placeholder={'Select providers'}
                                    disabled={selectedOrganizationName.organization_id===''||selectedSubdivisionId===''||providerResult?.isFetching}
                                    data={providerDataList}
                                    setProviderDataList={setProviderDataList}
                                    index={0}
                                    isProvidersOpen={isProvidersOpen}
                                    setIsProvidersOpen={setIsProvidersOpen}
                                    setLinkOrganizationModel={setLinkOrganizationModel}
                                    selectedSubdivisionId={selectedSubdivisionId}
                                    selectedOrganizationId={selectedOrganizationName?.organization_id}
                                    value={(providerArr?.length>0)?`${providerArr?.length} Selected`:''}
                                    providerResult={providerResult?.data?.data?.map((item)=>item.providerUserData?.user_id)}
                                    isFetching={providerDataLoading}
                                    setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                                    setIsObserverAddOrDelete={setIsObserverAddOrDelete}
                                    setProviderDataLoading={setProviderDataLoading}
                                    noLabel={true}
                                />
                            </div>
                        </div>}
                        <div>
                            {edit?((providerResult.status !== "fulfilled" && providerResult.status !== "rejected") || (providerResult === undefined && providerResult.status !== "fulfilled" && providerResult.status !== "rejected")) ?
                                <CustomOverLay Active text="Loading Provider list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_monitor_overlay3' : 'overlay-list-monitor3'}`} /> : <>
                                    <ProviderTable
                                        providerResult={providerResult}
                                        setIsObserverAddOrDelete={setIsObserverAddOrDelete}
                                        setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                                        handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                        changeProviderAccess={changeProviderAccess}
                                        setChangeProviderAccess={setChangeProviderAccess}
                                        billingAgent={billingAgent}
                                        setBillingAgent={setBillingAgent}
                                        sendAlert={sendAlert}
                                        setSendAlert={setSendAlert}
                                        setIsAnyFieldFilled={setIsAnyFieldFilled}
                                        providerSmsAlert={providerSmsAlert}
                                        setProviderSmsAlert={setProviderSmsAlert}
                                        providerEmailAlert={providerEmailAlert}
                                        setProviderEmailAlert={setProviderEmailAlert}
                                        providerMissedReading={providerMissedReading}
                                        setProviderMissedReading={setProviderMissedReading}
                                    />
                                </>:''}
                        </div>

                        {edit&&<div className='w-full mb-5 mt-5'>
                            <p className='pt-2.5 min-w-fit text-base font-semibold text-[#972E4C]' id="carepartner-list">Care Partners List</p>
                            <div className='xl:w-1/3 lg:w-1/2 px[18px] pt-4'>
                                <ObserversDropdownwithSearch
                                    label={""}
                                    id={`observers`}
                                    placeholder={'Select care partners'}
                                    disabled={selectedOrganizationName.organization_id===''||selectedSubdivisionId===''||observerResult?.isFetching}
                                    data={observerDataList}
                                    setMonitorDataList={setObserverDataList}
                                    index={0}
                                    isMonitorsOpen={isObserversOpen}
                                    setIsMonitorsOpen={setIsObserversOpen}
                                    setLinkOrganizationModel={setLinkOrganizationModel}
                                    selectedSubdivisionId={selectedSubdivisionId}
                                    selectedOrganizationId={selectedOrganizationName?.organization_id}
                                    value={(observerArr?.length>0)?`${observerArr?.length} Selected`:''}
                                    monitorResult={observerResult}
                                    isFetching={observerDataLoading}
                                    setIsProviderAddOrDelete={setIsObserverAddOrDelete}
                                    setMonitorDataLoading={setObserverDataLoading}
                                    noLabel={true}
                                />
                            </div>
                        </div>}
                        <div>
                            {edit?((observerResult.status !== "fulfilled" && observerResult.status !== "rejected") || (observerResult === undefined && observerResult.status !== "fulfilled" && observerResult.status !== "rejected")) ?
                                <CustomOverLay Active text="Loading Care Partner list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_monitor_overlay3' : 'overlay-list-monitor3'}`} /> : <>
                                    <ObserverTable
                                        providerResult={observerResult}
                                        setIsProviderAddOrDelete={setIsObserverAddOrDelete}
                                        handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                        setIsAnyFieldFilled={setIsAnyFieldFilled}
                                        observerSmsAlert={observerSmsAlert}
                                        setObserverSmsAlert={setObserverSmsAlert}
                                        observerEmailAlert={observerEmailAlert}
                                        setObserverEmailAlert={setObserverEmailAlert}
                                        observerMissedReading={observerMissedReading}
                                        setObserverMissedReading={setObserverMissedReading}
                                        observerReadingReceived={observerReadingReceived}
                                        setObserverReadingReceived={setObserverReadingReceived}
                                    />
                                </>:''}
                        </div>
                        {confirmationDeleteCaseManagerDetails && 
                        <AnimatedModel 
                            Children={
                                <ConfirmationPrompt
                                    emptyField={emptyArea}
                                    setEmptyField={setEmptyArea}
                                    handleOnCLickActivate={deleteContactDetails}
                                    handleClose={()=>{setEmptyArea(''),setConfirmationDeleteCaseManagerDetails(false)}}
                                    tittle={'Delete'}
                                    message={`Are you sure you want to delete this case manager contact details?`}
                                    textMessage = {true===false?false:true}
                                    buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                    CancelButton={'No'}
                                />
                            }
                        /> 
                        }
                        {confirmationDeleteEmergencyDetails && 
                        <AnimatedModel 
                            Children={
                                <ConfirmationPrompt
                                    emptyField={emptyArea}
                                    setEmptyField={setEmptyArea}
                                    handleOnCLickActivate={deleteEmergencyContactDetails}
                                    handleClose={()=>{setEmptyArea(false),setConfirmationDeleteEmergencyDetails()}}
                                    tittle={'Delete'}
                                    message={`Are you sure you want to delete this emergency contact details?`}
                                    textMessage = {true===false?false:true}
                                    buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                    CancelButton={'No'}
                                />
                            }
                        /> 
                        }
                        {deleteModel &&
                        <AnimatedModel
                            Children={
                                <ConfirmationPrompt
                                    handleOnCLickActivate={()=>{setIsMonitorPopupClick(false),isObserverAddOrDelete?handleConfirmDeleteObserver():isProviderAddOrDelete?handleConfirmDelete('provider'):handleConfirmDelete()}}
                                    handleClose={handleCloseDeleteModal}
                                    tittle={'Remove'}
                                    message={`Are you sure you want to remove the associated ${isObserverAddOrDelete?'care partner':isProviderAddOrDelete?'provider':'monitor'} from the patient?`}
                                    buttonName={"Confirm"}
                                    loadingActivation={deleteLoading}
                                    CancelButton={"No"}
                                    disabled={deleteLoading}
                                />
                            }
                        />}
                        {linkOrganizationModel &&
                        <AnimatedModel
                            Children={
                                <ConfirmationPrompt
                                    handleOnCLickActivate={()=>{setIsMonitorPopupClick(false),isObserverAddOrDelete?handleAddObserverAssociation():isProviderAddOrDelete?handleAddAssociation('provider'):handleAddAssociation()}}
                                    handleClose={handleCloseLinkModel}
                                    tittle={'Associate'}
                                    message={`Are you sure you want to associate the selected ${isObserverAddOrDelete?(""):isProviderAddOrDelete?'providers?':'monitor users?'}`}
                                    extramsg={isObserverAddOrDelete&&'care partners?'}
                                    buttonName={"Yes"}
                                    loadingActivation={deleteLoading}
                                    CancelButton={"No"}
                                    disabled={deleteLoading}
                                />
                            }
                        />}
                        {confirmationStateStatus && 
                        <AnimatedModel 
                            Children={
                                <ConfirmationPrompt
                                    emptyField={emptyArea}
                                    setEmptyField={setEmptyArea}
                                    setTextAreaMsg={setTextAreaMsg}
                                    textAreaMsg={textAreaMsg}
                                    disabled={loadingStatus}
                                    loadingActivation={loadingStatus}
                                    handleOnCLickActivate={handleOnCLickChangeStatus}
                                    handleClose={handleConformationClickStatus}
                                    tittle= {statusToggle?'Activate':'Deactivate'}
                                    message = {`Are you sure you want to ${statusToggle? 'activate' : 'deactivate'} this patient?`}
                                    textMessage = {statusToggle===false?false:true}
                                    buttonName = {statusToggle?'Activate':'Deactivate'}
                                />
                            }
                        /> 
                        }
                    </div>}
                
            </div>
        </>
    )}


export default AddPatients;
